import { render, staticRenderFns } from "./Molenbergnatie.vue?vue&type=template&id=463dba0a&"
import script from "./Molenbergnatie.vue?vue&type=script&lang=ts&"
export * from "./Molenbergnatie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports